import { analysisInitialState } from "../reducers/analysisViewReducer";

const type = 'ANALYSIS_VIEW';

export const updateAnalysisView = (payload) => async dispatch => {
	dispatch({type, payload });
}

export const emptyAnalysisSection = () => async dispatch => {
	dispatch({type, analysisInitialState})
}